import { LiveStreamCreator } from '@/components/LiveSelling/LiveStreamCreator';
import { useUserContext } from '@/context/AuthContext';

export default function CreateStreamPage() {
  const { user } = useUserContext();
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6">Start Selling Live</h1>
      <LiveStreamCreator 
        userId={user.id}
        userName={user.username}
        onStartStream={(streamId) => {
          // Redirect to the live stream
          window.location.href = `/live/${streamId}`;
        }} 
      />
    </div>
  );
}